import React from 'react';

export function ExploreMoreLinks() {
  return (
    <div className="w-full flex flex-col items-center mb-24">
      <h2 className="text-2xl font-bold text-white mb-8 text-center">Explore More</h2>
      <div className="flex flex-col md:flex-row gap-4 items-center">
        <a
          href="/gallery"
          className="px-4 py-2 bg-black/80 text-white rounded-full shadow border border-gray-800 hover:bg-[#121212] hover:border-gray-700 transition"
        >
          See more builds in the gallery
        </a>
        <a
          href="/articles"
          className="px-4 py-2 bg-black/80 text-white rounded-full shadow border border-gray-800 hover:bg-[#121212] hover:border-gray-700 transition"
        >
          Read more articles
        </a>
        <a
          href="/soundtests"
          className="px-4 py-2 bg-black/80 text-white rounded-full shadow border border-gray-800 hover:bg-[#121212] hover:border-gray-700 transition"
        >
          Listen to more sound tests
        </a>
      </div>
    </div>
  );
}

export function ArticleTitleSection({image, title, date, status}) {
  const STATUS_STYLES = {
    new: { dot: 'bg-blue-500', text: 'text-blue-400', label: 'New' },
    updated: { dot: 'bg-green-500', text: 'text-green-400', label: 'Updated' },
    outdated: { dot: 'bg-red-500', text: 'text-red-400', label: 'Outdated' }
  };
  return (
    <>
      {/* Full-screen hero image */}
      <div className="w-full h-[50vh] md:h-[70vh] relative flex items-center justify-center">
        <img
          src={image}
          alt={title + ' Hero'}
          className="absolute inset-0 w-full h-full object-cover object-center z-0 shadow-lg"
          style={{filter: 'brightness(0.8)'}}
        />
      </div>
      {/* Gray bar underneath the banner image */}
      <div className="w-full bg-black/80 py-4 border-b border-gray-800 rounded-b-lg flex flex-col md:flex-row md:items-center md:justify-between px-4 md:px-8 mb-16 gap-2 md:gap-0">
        <h2 className="text-2xl font-semibold text-gray-300 text-center md:text-left w-full md:w-auto">{title}</h2>
        <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 mt-2 md:mt-0 text-[16px] text-gray-300 justify-center md:justify-start w-full md:w-auto">
          <span className="text-center md:text-left">Published: </span>
          <span className='text-center md:text-left ml-[-11px]'>
            {new Date(date).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
          </span>
          {status && STATUS_STYLES[status] && (
            <span className="flex items-center gap-2 justify-center md:justify-start">
              <span className={`inline-block w-2.5 h-2.5 rounded-full ${STATUS_STYLES[status].dot}`}></span>
              <span className={`text-xs font-semibold tracking-wide uppercase ${STATUS_STYLES[status].text}`}>{STATUS_STYLES[status].label}</span>
            </span>
          )}
        </div>
      </div>
    </>
  );
}

// Example usage of ArticleTitleSection
// <ArticleTitleSection
//   image='/pictures/articles/envoy/banner.jpg'
//   title='Mode Envoy Review'
//   date={article.date}
//   status={article.status}
// />